<template>
    <el-form
        v-if="showPageInfo"
        class="category-attr" :model="formData" :rules="rules" ref="form">
        <!-- <div class="smart-match-tip" v-if="showMatchTip">
            <div>
                <div><i class="el-icon-warning-outline icon"></i>系统已自动预测类目属性，如信息正确可点击智能填充</div>
                <div class="match-infos">
                    <span v-for="(matchProp, indx) in matchPropNames" :key="matchProp.propName + indx" style="margin-right: 10px;"> {{ matchProp.propName}}: {{ matchProp.propValue }} </span>
                </div>
            </div>
            <div>
                <el-button type="primary" class="fill-btn" @click="oneClickFill">一键填充</el-button>
                <el-button type="link" class="delete-btn" @click="showMatchTip=false">x</el-button>
            </div>
        </div> -->
        <div class="attr-item" v-for="(item, idx) in attrs"
            :key="item.propertyId"
            :class="{'multi-measure-item': 'multi_value_measure' === getPropType(item) || item.type === 'nutrition', 'measure-item': ['measure', 'date_time_range'].includes(getPropType(item))}"
        >
            <el-form-item :label="item.propertyName" label-position="top" :prop="String(item.propertyId)" :key="item.propertyId">
                <div style="display:inline-block;width:100%;" v-if="item.propertyPicAvailable === 1">
                    <span style="color:#606266;font-size:12px;">水洗标/吊牌图</span>
                    <MutiImgUpload
                        v-model="propertyPics[item.propertyId]" 
                        :mainImgNums="0"
                        :limitNums="1"  
                        :emptyError="item.propertyPicRequired === 1 && propertyPics[item.propertyId].length === 0"
                        show-audit-result
                    />
                </div>
                <el-select 
                    width="180px" 
                    v-if="getPropType(item) === 'select'" 
                    v-model="formData[item.propertyId]" 
                    @change="(val) => handleSelectChange(val, item)" 
                    :data-id="item.propertyName" 
                    :key="idx" 
                    placeholder="请选择"
                    filterable
                    clearable
                    :multiple="item.type === 'multi_select'"
                    :popper-append-to-body="false"
                    :clearNoExistValue="item.diyType === 1 ? false : true"
                    :allow-create="item.diyType === 1"
                >
                    <el-option
                        v-for="(op, opidx) in item.options"
                        :key="item.propertyId + '-' + opidx + op.value"
                        :label="op.name"
                        :value="op.value">
                    </el-option>
                </el-select>
                <MultiMeasure v-else-if="['multi_value_measure', 'measure', 'date_time_range'].includes(getPropType(item))" :props="item" v-model="formMeasureData[item.propertyId]"></MultiMeasure>
                <NutritionTable v-else-if="item.type === 'nutrition'" :props="item" v-model="formMeasureData[item.propertyId]"></NutritionTable>
                <!-- 营养成分表 -->
                
                <el-input
                    v-else
                    type="text"
                    placeholder="请输入"
                    @input="val => categoryChange(val, item)"
                    v-model="formData[item.propertyId]"
                    >
                </el-input>
                
            </el-form-item>
        </div>
        <template v-if="isShowRefresh">
            <span class="update-brand">找不到商品属性？
                <el-link :underline="false" @click="fetchAttrs(true)">刷新数据</el-link>
            </span>
        </template>
    </el-form>
</template>

<script>
import MultiMeasure from './MultiMeasure.vue'
import NutritionTable from './NutritionTable.vue'
// import { getCategoryAndPropertiesMatch } from '@/servers/prod/center'
import { getFxgCategoryProperties } from '@/servers/prod/center/fxg.js';
import { genVoidOption, genReqiuredRule, genClothingsRule, genMutilMeasureRule, genNutritionRule } from "./categoryAttrHelper";
import { mapGetters, mapActions } from 'vuex';
import { cloneDeep } from 'lodash';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'

//  <CategoryAttr v-model="value.productFormat" :initAttrData="initAttrData" :categoryIds="value.categoryIds" ref="categoryAttr"/>
// initAttrData: 后台传的productFormat
// productFormat: 属性值 属性名称|属性值 之间用|分隔, 多组之间用^分开：货号|8888^上市年份季节|2018年秋季 旧版
// productFormat: { 属性id: [{value: 属性值id, name: 属性值name, diyType: 属性diyType}] } 新版
// 校验表单数据this.$refs.categoryAttr.validate();
export default {
  model: {
      prop: 'value',
      event: 'change'
  },
  props: {
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    },
    self_form: {
      type: Object,
      default() {
        return {}
      }
    },
    value: {
        type: String,
        default: ''
    },
    categoryProperties:{
        type: Array,
        default() {
            return []
        }
    },
    initAttrData: {
        type: Object,
        default() {
            return {}
        }
    },
    initMeasureData: {
        type: Object,
        default() {
            return {}
        }
    },
    baseItemId: [Number, String],
    getPrefix: Function,
    namePrefix:{
        type: String
    },
    isShowRefresh:{
        type: Boolean,
        default: true
    },
    categoryPropertyPics:{
        type:Object,
        default() {
            return {}
        }
    },
    source:{ // 引入来源
        type:String,
        default:''
    }
  },
  components: {
    MultiMeasure,
    NutritionTable,
    MutiImgUpload
  },
  data() {
      return {
        rules: {},
        attrs: [],
        formData: {},
        formMeasureData: {},
        attrValues: {},
        voidOptionMap: {},
        showPageInfo: false,
        attrList:[],
        hasSubPropertyIds: [],
        propertyPics:{}
      }
  },
  computed: {
      ...mapGetters(['shops_getCategoryPropShopId']),
      categoryId() {
          if (!this.categoryIds.length) return '';
          return this.categoryIds[this.categoryIds.length - 1];
      },
      shopId() {
        return this.shops_getCategoryPropShopId('fxg') || 76398
      }
  },
  watch: {
    categoryId: {
        handler(id) {
            this.formData = {}
            this.formMeasureData = {}
            this.rules = {}
            if(id) {
                this.$refs?.form?.clearValidate()
                if(!this.categoryProperties.length) {
                    this.fetchAttrs();
                }
            }
        
        },
        immediate: true
    },
    formData: {
        deep: true,
        handler(v) {
            let res = {};
            for (let key in v) {
                if (v[key]) {
                    const itemValue = this.getItemValue(v[key], key)
                    if(!itemValue) continue
                    res[key] = itemValue
                } else if (this.rules[key]?.find(({required}) => required) && this.voidOptionMap[key]) {
                    res[this.voidOptionMap[key]] = []
                }
            }
            this.attrValues = res
            this.updateValue()
        }
    },
    formMeasureData: {
        handler(val) {
            this.updateValue()
            this.$nextTick(() => {
                this.validate()
            })
        },
        deep: true
    },
    initAttrData: {
        handler(val) {
            if(Object.keys(val).length) {
                this.formData = {}
                this.updateFormData();
            }
        },
        immediate: true
    },
    propertyPics:{
        handler(val){
            this.$emit('changePropertyPics',val)
        },
        deep:true
    }
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    async fetchAttrs(isUpdate, extraParams) {
        isUpdate && this.updateCatePropShopIndex('fxg');
        const lastHasSubPropertyIds = cloneDeep(this.hasSubPropertyIds);
        const data = await getFxgCategoryProperties({
            shopId: this.shopId,
            leafCategoryId: this.categoryId,
            ...extraParams,
        });
        this.$emit('fetchAttrs', data)
        this.attrList = data;
        this.hasSubPropertyIds = data.filter(item => item.hasSubProperty).map(item => item.propertyId);
        this.updateFormData();
        if (this.hasSubPropertyIds.length && lastHasSubPropertyIds.sort().join(',') !== this.hasSubPropertyIds.sort().join(',')) {
            this.$nextTick(() => {
                this.subPropertyFetchAttrs();
            })
        }
    },
    subPropertyFetchAttrs() {
        const productFormatNew = {}
        this.hasSubPropertyIds.forEach(id => {
            const itemValue = this.getItemValue(this.formData[id], id)
            if(itemValue) {
                productFormatNew[id] = itemValue
            }
        })
        this.fetchAttrs(false, { productFormatNew: JSON.stringify(productFormatNew), needProcessPropCascade: true })
    },
    getItemValue(itemValue, key) {
        if (!itemValue) return null

        const attr = this.attrs.find(a => String(a.propertyId) === String(key))
        if (!attr) return null

        const { options, diyType, propertyName } = attr
        const propType = this.getPropType(attr)
        const buildItem = (value, name) => ({
            value,
            name,
            diy_type: Number(diyType),
            propertyName
        })

        // 多选：值是数组
        if (Array.isArray(itemValue)) {
            if (!itemValue.length || !options?.length) return null
            return itemValue.map(v => {
                const isNewVersion = !isNaN(Number(v))
                if (isNewVersion) {
                    const match = options.find(o => o.value == v)
                    return match ? buildItem(Number(v), match.name) : buildItem(0, String(v))
                }
                // 老版值是字符串名称
                const match = options.find(o => o.name === v)
                return buildItem(match ? match.value : 0, v)
            })
        }

        // 非下拉框或值为非数字字符串（老版数据）
        if (isNaN(Number(itemValue)) || propType !== 'select') {
            const value = options?.length ? (options.find(o => o.name === itemValue)?.value || 0) : 0
            return [buildItem(value, itemValue)]
        }

        // 下拉框：值是数字 id
        const matchItem = options?.find(o => Number(o.value) === Number(itemValue))
        if (matchItem) {
            return [buildItem(Number(itemValue), matchItem.name)]
        }
        return [buildItem(0, String(itemValue))]
    },
    updateFormData() {
        this.showPageInfo = false;
        const isFirstUpdate = !Object.keys(this.formData)?.length
        const data = cloneDeep(this.attrList);
        if (data) {
            const initAttrData = this.initAttrData;
            let rules = {};
            let _propertyPics = {}
            this.voidOptionMap = {};
            this.attrs = data.filter(item => item.status !== 1 && item.propertyName !== '品牌' && (item.featureTypeList && !item.featureTypeList.includes(48))).map((item) => {
                let itemRules = [];
                if (item.options && !['multi_value_measure', 'measure', 'date_time_range'].includes(item.type)) {
                    try {
                        item.options = JSON.parse(item.options).map(op => ({...op, value: Number(op.value)}));
                        let propertyId = genVoidOption(item)
                        if (propertyId) {
                            this.voidOptionMap[item.propertyId] = propertyId
                        }
                    } catch(e) {
                        console.error(e);
                    }
                }
                // 多模块度量衡处理 （例子： ‘面料材质）
                if(['multi_value_measure', 'measure', 'date_time_range'].includes(item.type)) {
                    itemRules.push({required: !!item.required, validator: genMutilMeasureRule(item, this.formMeasureData, !!item.required, this.self_form,{
                        _this:this
                    }), trigger: 'change'})
                    itemRules.push({required: !!item.required, validator: genNutritionRule(item, this.formMeasureData, !!item.required), trigger: 'change'})
                } else if(item.required === 1) {
                    const text  = this.getPropType(item) === 'select' ? '请选择' : '请输入';
                    itemRules.push({required: true, validator: genReqiuredRule(item, text), trigger: 'change'})
                }
                if (item.type === "multi_select" && item.options?.length && item.multiSelectMax) {
                    // 最大多选数
                    itemRules.push({ type: 'array', max: item.multiSelectMax, message: `选择不能超过${item.multiSelectMax}个`})
                }
                if(['填充物种类', '充绒量', '绒子含量'].includes(item.propertyName)) {
                    itemRules = genClothingsRule(item, this.self_form)
                }

                let val = ''
                if(!isFirstUpdate) {
                    val = this.formData[item.propertyId]
                } else if (Object.keys(initAttrData).every(key => !isNaN(Number(key)))) {
                    // 若key都是数字，代表是新版数据，取item.propertyId就好
                    val = initAttrData[item.propertyId] || ''
                } else {
                    val = initAttrData[item.propertyName] || ''
                }
                if (item.type === 'multi_select') {
                    if (['number', 'string'].includes(typeof val)) {
                        val = val ? [val] : [];
                    }
                }
                // 对有值的下拉框做一个值与下拉选项匹对，若没匹配上，则需要将值置空，多选则需要移除值
                if (val) {
                    if (item.type === 'select' && item.diyType === 0 && (!item.options.find(({value}) => val == value))) {
                        val = ''
                    } else if (item.type === 'multi_select' && item.diyType === 0) {
                        val = (val || []).filter(v => {
                            return item.options.find(({value}) => v == value)
                        })
                    }
                }
                if(['multi_value_measure', 'measure', 'date_time_range', 'nutrition'].includes(item.type)) {
                    const measureItemValue = isFirstUpdate ? this.initMeasureData[item.propertyId] : this.formMeasureData[item.propertyId]
                    this.$set(this.formMeasureData, item.propertyId, measureItemValue || []);
                } else {
                    this.$set(this.formData, item.propertyId, val);
                }
                // 属性图初始化
                if(item.propertyPicAvailable === 1){
                    _propertyPics[item.propertyId] = this.initPropertyPics(item)
                }

                rules[item.propertyId] = itemRules;
                return item;
            });
            this.rules = rules;
            this.propertyPics = _propertyPics
            this.showPageInfo = true;
            this.$nextTick(() => {
                this.$emit('refundRuleChange', cloneDeep(this.attrs));
                this.validate()
            })
        }
    },
    getPropType(item) {
        if(item?.options?.length && (["select", "multi_select", "text"].includes(item.type))) {
            return 'select'
        } else {
            return item.type
        }
    },
    updateValue() {
        this.$emit('change', JSON.stringify({...this.attrValues, ...this.formMeasureData}));
    },
    validate() {
        return new Promise((resolve) => {
            this.$refs.form && this.$refs.form.validate(valid => {
                resolve(valid);
            })
        })
    },
    handleSelectChange(value, item) {
        const { options, propertyId, cid, diyType } = item;
        const matchOption = options.find(item => {
            return item.value === value;
        });
        const valueName = matchOption ? matchOption.name : '';
        const cascadeInfo = [{
            valueName: (!valueName && diyType === 1) ? value : valueName,
            valueId: (!valueName && diyType === 1) ? 0 : value,
            cascadeId: cid,
        }]
        this.$emit('select-changed', { value, propertyId, cascadeInfo })
        this.categoryChange(value, item);
    },
    //类目属性变化
    categoryChange(_value, item){
        if(this.hasSubPropertyIds.includes(item.propertyId)) {
            this.$nextTick(() =>{
                this.subPropertyFetchAttrs()
            })
            return
        }
        this.$forceUpdate();
        if(this.namePrefix){
            this.$nextTick(() => {
                this.getPrefix();
            });
        }
    },
    initPropertyPics(propertyItem){
        let categoryPropertyPics = this.categoryPropertyPics || {}
        if(Object.keys(categoryPropertyPics).length === 0){
            categoryPropertyPics = this.self_form.categoryPropertyPics || {}
        }
        let pics = categoryPropertyPics[propertyItem.propertyId]
        if(pics){
            return pics.urls || []
        }
        return [];     
    },
    // async getCategoryPropertiesMatchData() {
    //     if(!this.categoryId || !this.baseItemId) return;
    //     const data = await getCategoryAndPropertiesMatch({
    //         baseItemId: this.baseItemId,
    //         categoryId: this.categoryId,
    //         platformType: 'fxg',
    //     })
    //     this.matchPropValues = data?.matchPropValues
    //     this.matchPropNames = data?.matchPropNames ? JSON.parse(data.matchPropNames) : []
    //     this.showMatchTip = !!this.matchPropNames.length;
    // },
    // oneClickFill() {
    //     this.$emit('oneClickFill', this.matchPropValues);
    // }
  }
}
</script>

<style lang="scss" scoped>
.category-attr {
    position: relative;
    .smart-match-tip {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: #fffbe6;
        border: 1px solid #ffe58f;
        border-radius: 2px;
        padding: 10px;
        font-size: 14px;
        width: 100%;
        color: #6c6d6f;
        .icon {
            color: #faad14;
            font-size: 24px;
            margin-right: 5px;
        }
        .match-infos {
            font-size: 12px;
            margin-left: 30px;
        }
        .fill-btn {
            margin-right: 30px;
        }
        .delete-btn {
            position: absolute;
            top: 10px;
            right: 20px;
            color: #979494;
        }
    }
    ::v-deep .el-select .el-input {
        width: 100% !important;
    }
    .el-select-dropdown{
        width: 180px;
    }
    .update-brand {
        position: absolute;
        left: 20px;
        bottom: 0;
        font-size: 12px;
    }
    .multi-measure-item {
        width: 100% !important;
    }
    .measure-item {
        width: 390px !important;
    }
    .el-form--inline .el-form-item {
        display: inline-block;
        margin-right: 4px;
        vertical-align: top;
    }
}
</style>
